// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"f9b4cd12","453":"38325b96","578":"b1cacc90"}[chunkId] + ".chunk.js";
};